import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6ac20ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "infoNotice"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "online-indicator"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'ChatbotIcon',
  props: {
    avatar: {
        type: String,
        required: true,
    },
    notificationCount: {
        type: Number,
        required: false
    },
    showOnlineIndicator: {
        type: Boolean,
        required: false,
        default: false
    },
    size: {
        type: Number,
        required: false,
        default: 7
    },
    hoverEffect: {
        type: Boolean,
        required: false,
        default: true
    },
    borderActive: {
        type: Boolean,
        required: false,
        default: false
    },
    backgroundColor: {
        type: String,
        required: true,
        default: '#3d3b8e'
    }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chatbot-logo", {hoverEffect: __props.hoverEffect, borderActive:  __props.borderActive}]),
    style: _normalizeStyle({ width: __props.size + 'em', height: __props.size + 'em', backgroundColor: __props.backgroundColor })
  }, [
    (__props.notificationCount && __props.notificationCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.notificationCount), 1))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: __props.avatar,
      style: _normalizeStyle({ width: __props.size + '.1em', height: __props.size + '.1em' })
    }, null, 12, _hoisted_2),
    (__props.showOnlineIndicator)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true)
  ], 6))
}
}

})